export default {
	'total-net': 'الصافي',
	'show-all-journal': 'عرض كل اليوميات',
	'enter-quantity': 'إدخال الكمية',
	'enter-item-by-barcode': 'إدخال عبر الباركود',
	'paper-document': 'المستند الورقي',
	'addition-item': 'إضافة مادة',
	'the-net-invoice-must-be-zero-and-this-requires-zeroing-all-financial-fields': 'يجب أن يكون صافي الفاتورة صفرياً وهذا يستدعي تصفير جميع الحقول المالية ',
	
	'confirm-user': 'تأكيد المستخدم'
}
